import React, { useRef, useEffect, useState } from 'react';
import './App.css';
import Footer from './Footer';

const images = [
  './images/yala.webp',
  './images/Y1.webp',
  './images/Y2.webp',
  './images/Y3.webp',
];

const TravelForm = () => {
  const carouselRef = useRef(null);
  const [lang, setLang] = useState('en');

  useEffect(() => {
    const scrollInterval = setInterval(() => {
      if (carouselRef.current) {
        const container = carouselRef.current;
        const maxScrollLeft = container.scrollWidth - container.clientWidth;

        if (container.scrollLeft >= maxScrollLeft) {
          container.scrollLeft = 0;
        } else {
          container.scrollLeft += 260;
        }
      }
    }, 2000);

    return () => clearInterval(scrollInterval);
  }, []);

  const content = {
    en: `Yala National Park is a breathtaking natural sanctuary where untamed wilderness meets serene landscapes. Spanning across the southeastern coast of Sri Lanka, Yala is celebrated for its rich biodiversity and awe-inspiring beauty. Home to elusive leopards, majestic elephants, sloth bears, and hundreds of bird species, the park offers one of the best wildlife experiences in Asia.

What makes Yala truly captivating is its striking contrast of ecosystems—dense jungles give way to golden savannahs, sparkling lagoons, ancient rock outcrops, and pristine beaches where the forest kisses the ocean. Each safari through Yala is a journey into the wild heart of nature, where silence speaks and every turn holds the promise of a thrilling encounter. Whether you're a wildlife enthusiast, photographer, or nature lover, Yala’s raw beauty and mystery will leave you enchanted and longing to return.`,

    zh: `雅拉国家公园是一片令人叹为观止的自然圣地，在这里，原始的荒野与宁静的风景交汇相融。公园横跨斯里兰卡东南海岸，以其丰富的生物多样性和令人惊艳的自然美景而闻名。这里是罕见的野生豹子、雄伟的大象、懒熊以及数百种鸟类的栖息地，是亚洲最出色的野生动物观赏地之一。

雅拉的迷人之处在于其多样而鲜明的生态系统——茂密的丛林与金色的草原交织，闪耀的潟湖、古老的岩石地貌以及与海洋相依的原始海滩共同构成一幅壮丽的自然画卷。在雅拉的每一次野生动物之旅，都是深入大自然野性心脏的探索之旅，寂静中蕴藏着惊喜，每一次转弯都可能遇见激动人心的邂逅。无论您是野生动物爱好者、摄影师，还是自然探索者，雅拉那原始的美与神秘必将让您流连忘返、心驰神往。`
  };

  return (
    <div className="travel-form-container2">
      {/* Row 1 - Description */}
      <div className="row row-one2">
        <div className="col image-col2">
          <img src="./images/yala.webp"  className="travel-image2" />
          <img src="./images/Y1.webp" className="travel-image2" />
        </div>

        <div className="col content-col2">
          <h2>Yala National Park</h2>

          {/* Language Toggle Button */}
          <div style={{ textAlign: 'right', marginBottom: '10px' }}>
            <button
              onClick={() => setLang(lang === 'en' ? 'zh' : 'en')}
              style={{
                padding: '8px 16px',
                borderRadius: '6px',
                border: 'none',
                backgroundColor: '#967969',
                color: 'white',
                cursor: 'pointer'
              }}
            >
              {lang === 'en' ? '切换到中文' : 'Switch to English'}
            </button>
          </div>

          {/* Paragraph */}
          <p style={{ whiteSpace: 'pre-line' }}>{content[lang]}</p>
        </div>
      </div>

      {/* Row 2 - Auto Carousel */}
      <div className="carousel-container2">
        <div className="carousel-heading-column">
          <h2 className="carousel-heading">Explore Yala</h2>
          <p className="carousel-subheading">A glimpse into wild beauty and untamed nature</p>
        </div>

        <div className="carousel2" ref={carouselRef}>
          {images.map((imgSrc, index) => (
            <img key={index} src={imgSrc} className="carousel-image2" />
          ))}
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default TravelForm;
